import { useCallback, useRef } from 'react';

import { IconVideo } from '@xing-com/icons';

import { ACCEPTED_VIDEO_FILES, MAX_VIDEO_SIZE } from '../../../constants';
import * as Styled from '../styles';
import { type VideoToolProps } from '../types';

export const isValidVideoFileSize = (file: File): boolean => {
  const maxAllowedSize = MAX_VIDEO_SIZE * 1024 * 1024;
  return file.size <= maxAllowedSize;
};

export const VideoTool: React.FC<VideoToolProps> = ({
  editor,
  disabled,
  onVideoUpload,
}) => {
  const inputFileRef = useRef<HTMLInputElement | null>(null);

  const handleVideoUpload = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!editor || !e.target.files?.length) {
        return;
      }

      const video = e.target.files.item(0) as File;
      if (isValidVideoFileSize(video)) {
        onVideoUpload?.(video, (_: string, videoId: string) => {
          editor
            .chain()
            .focus()
            .addXingVideo(videoId)
            .createParagraphNear()
            .run();
        });
      }

      e.target.value = '';
    },
    [editor, onVideoUpload]
  );

  return (
    <div>
      <Styled.ToolBarButton
        onClick={() => {
          inputFileRef.current?.click?.();
        }}
        disabled={disabled}
      >
        <IconVideo width={24} height={24} />
      </Styled.ToolBarButton>
      <input
        ref={inputFileRef}
        data-qa="articles-video-tool-input"
        data-testid="articles-video-tool-input"
        type="file"
        accept={ACCEPTED_VIDEO_FILES}
        onChange={handleVideoUpload}
        hidden
      />
    </div>
  );
};
